module.exports = __webpack_public_path__ + "static/media/clock-gray.322f302c.svg";